module.exports = __webpack_public_path__ + "img/banner-tablet.0fcc348f.jpg";